import * as layout from '../../../components/markLayout.module.css';
import { MarkInput, MarkLabel } from '../../../components/MarkControls';
import React, { useId } from 'react';
type Props = {
    value: string | null;
    onChange: (value: string | null) => void;
    disabled?: boolean;
};
const parseDuration = (
    iso: string | null
): {
    days: number;
    hours: number;
    minutes: number;
} => {
    if (!iso) return { days: 0, hours: 0, minutes: 0 };
    const d = iso.match(/(\d+)D/);
    const h = iso.match(/(\d+)H/);
    const m = iso.match(/(\d+)M/);
    return {
        days: d ? Number(d[1]) : 0,
        hours: h ? Number(h[1]) : 0,
        minutes: m ? Number(m[1]) : 0
    };
};
const buildDuration = (days: number, hours: number, minutes: number): string | null => {
    if (days === 0 && hours === 0 && minutes === 0) return null;
    let s = 'P';
    if (days > 0) s += `${days}D`;
    if (hours > 0 || minutes > 0) {
        s += 'T';
        if (hours > 0) s += `${hours}H`;
        if (minutes > 0) s += `${minutes}M`;
    }
    return s;
};
const DurationInput: React.FC<Props> = ({ value, onChange, disabled }) => {
    const baseId = useId();
    const { days, hours, minutes } = parseDuration(value);
    const handleChange = (field: 'days' | 'hours' | 'minutes', raw: string) => {
        const n = Math.max(0, Math.floor(Number(raw) || 0));
        const d = field === 'days' ? Math.min(n, 365) : days;
        const h = field === 'hours' ? Math.min(n, 23) : hours;
        const m = field === 'minutes' ? Math.min(n, 59) : minutes;
        onChange(buildDuration(d, h, m));
    };

    return (
        <div className={layout.durationGrid}>
            <div className={layout.field}>
                <MarkLabel
                    htmlFor={`${baseId}-d`}
                    style={{
                        display: 'block',
                        marginBottom: '0.2rem'
                    }}
                >
                    Days
                </MarkLabel>
                <MarkInput
                    id={`${baseId}-d`}
                    type="number"
                    min={0}
                    max={365}
                    value={days}
                    onChange={(e) => handleChange('days', e.currentTarget.value)}
                    disabled={disabled}
                    style={{
                        textAlign: 'center'
                    }}
                />
            </div>
            <div className={layout.field}>
                <MarkLabel
                    htmlFor={`${baseId}-h`}
                    style={{
                        display: 'block',
                        marginBottom: '0.2rem'
                    }}
                >
                    Hours
                </MarkLabel>
                <MarkInput
                    id={`${baseId}-h`}
                    type="number"
                    min={0}
                    max={23}
                    value={hours}
                    onChange={(e) => handleChange('hours', e.currentTarget.value)}
                    disabled={disabled}
                    style={{
                        textAlign: 'center'
                    }}
                />
            </div>
            <div className={layout.field}>
                <MarkLabel
                    htmlFor={`${baseId}-m`}
                    style={{
                        display: 'block',
                        marginBottom: '0.2rem'
                    }}
                >
                    Minutes
                </MarkLabel>
                <MarkInput
                    id={`${baseId}-m`}
                    type="number"
                    min={0}
                    max={59}
                    value={minutes}
                    onChange={(e) => handleChange('minutes', e.currentTarget.value)}
                    disabled={disabled}
                    style={{
                        textAlign: 'center'
                    }}
                />
            </div>
        </div>
    );
};
export default DurationInput;
